import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaDownload,
} from "react-icons/fa";
import SideBar from "../../components/Sidebar";

const BillPaymentOrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    category,
    logo,
    selectedOperator,
    paramsFields,
    billData,
    amount,
    commercialData,
    responseData,
  } = location.state || {};

  const data = responseData?.data || {};
  const status = responseData?.status || "PENDING";
  const message = responseData?.message || "Processing your request...";

  const getStatusIcon = (status) => {
    switch (status) {
      case "SUCCESS":
        return <FaCheckCircle size={50} color="green" />;
      case "FAILED":
        return <FaTimesCircle size={50} color="red" />;
      default:
        return <FaClock size={50} color="#ffc107" />;
    }
  };

  const getStatusTextClass = (status) => {
    switch (status) {
      case "SUCCESS":
        return "text-success fw-bold fs-5";
      case "FAILED":
        return "text-danger fw-bold fs-5";
      default:
        return "text-warning fw-bold fs-5";
    }
  };

  const getMessageTextClass = (status) => {
    switch (status) {
      case "SUCCESS":
        return "text-success fw-bold";
      case "FAILED":
        return "text-danger fw-bold";
      default:
        return "text-warning fw-bold";
    }
  };

  const handleDownloadReceipt = () => {
    alert("Download receipt feature is coming soon.");
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-5">
          <div
            className="card p-4 shadow-sm"
            style={{ minHeight: "80vh", backgroundColor: "#f8f9fa" }}
          >
            <h4 className="text-center fw-bold mb-4">Order Confirmation</h4>

            <div className="d-flex justify-content-center">
              <div
                className="card p-4 shadow-sm"
                style={{
                  maxWidth: "530px",
                  width: "100%",
                  borderRadius: "16px",
                  backgroundColor: "#ffffff",
                }}
              >
                {/* Top logo and status section */}
                <div
                  className="position-relative mb-3"
                  style={{ minHeight: "80px" }}
                >
                  {/* Centered Content */}
                  <div className="text-center">
                    {getStatusIcon(status)}
                    <div
                      className={`${getMessageTextClass(status)} fw-bold mt-1`}
                      style={{ fontSize: "16px" }}
                    >
                      {message}
                    </div>
                  </div>

                  {/* Right-Aligned B-Assured Logo */}
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <img
                      src="/assets/images/b_assured_logo.png"
                      alt="b-assured-logo"
                      width={70}
                    />
                  </div>
                </div>

                {/* Section 1: Recharge Details */}
                {/* Recharge Details Box */}
                <div className="border rounded p-3 mb-3 bg-light">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0">Transaction Details</h6>
                    {logo && (
                      <img
                        src={logo}
                        alt="Operator Logo"
                        style={{ maxHeight: "30px", objectFit: "contain" }}
                      />
                    )}
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Biller Name</div>
                    <div className="fw-bold">
                      {selectedOperator.operator_name || "N/A"}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Bill Number</div>
                    <div className="fw-bold">
                      {billData.customer_ref_id || "N/A"}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Bill Amount</div>
                    <div className="fw-bold">₹{amount || "0.00"}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Order ID</div>
                    <div className="fw-bold">{data.order_id || "N/A"}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">B-Connect TXN ID</div>
                    <div className="fw-bold">
                      {data.operator_ref_id || "N/A"}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="text-muted">Date & Time</div>
                    <div className="fw-bold">{data.timestamp || "N/A"}</div>
                  </div>
                </div>

                {commercialData && (
                  <li className="list-group-item d-flex justify-content-between bg-light mb-3">
                    <span className="text-success fw-bold">Discount</span>
                    <span className="fw-bold text-success">
                      ₹{commercialData.commercial_amount}
                    </span>
                  </li>
                )}

                {/* Section 2: Balance Info */}
                {(data.opening_balance ||
                  data.debit_amount ||
                  data.closing_balance) && (
                  <div className="border rounded p-3 mb-3 bg-light">
                    <div className="d-flex justify-content-between text-center">
                      <div>
                        <div className="text-muted small">Opening Bal</div>
                        <div className="fw-bold">
                          ₹{responseData.data.opening_bal || "0.00"}
                        </div>
                      </div>
                      <div>
                        <div className="text-muted small">Amount</div>
                        <div className="fw-bold" style={{ color: "red" }}>
                          - ₹{responseData.data.debit_amount || "0.00"}
                        </div>
                      </div>
                      <div>
                        <div className="text-muted small">Closing Bal</div>
                        <div className="fw-bold">
                          ₹{responseData.data.closing_bal || "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Action Buttons */}
                <div className="d-flex gap-2 mt-2">
                  <button
                    className="btn btn-outline-secondary btn-sm w-100"
                    onClick={handleDownloadReceipt}
                  >
                    <FaDownload className="me-2" />
                    Receipt
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() => navigate("/recharge-and-bill-payment")}
                  >
                    Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillPaymentOrderConfirmation;
